/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import type {VNode} from 'snabbdom';
import type {JsxVNodeChildren} from 'snabbdom-jsx-lite';

import {HORIZONTAL_CONTENT_PADDING_STYLE} from 'common/report/layout/content-layout';
import {layoutManager} from 'common/report/util/layout-manager';

export const MIN_PAGE_WIDTH = 1150; // px

export function ContentFrame(
  {
    sel,
    contentFrameClass,
    minContentWidth,
    maxContentWidth,
    isDownloadMode = false,
    includePadding = true,
    onPaddingFrameInsert = null,
    isReportScrollContainer = false,
    isBoardsToReportsEnabled = false,
  }: {
    sel?: string;
    contentFrameClass?: Record<string, boolean>;
    minContentWidth?: number;
    maxContentWidth?: number;
    includePadding?: boolean;
    isDownloadMode?: boolean;
    onPaddingFrameInsert?: (paddingFrame: VNode) => void;
    isReportScrollContainer?: boolean;
    isBoardsToReportsEnabled?: boolean;
  },
  block: JsxVNodeChildren,
): VNode {
  // we don't want to apply any content width restrictions in Download Mode
  if (isDownloadMode) {
    return (
      <div sel={sel} class={{'inherit-size': isBoardsToReportsEnabled}}>
        {block}
      </div>
    );
  }

  return (
    <div
      sel={sel}
      class={{
        ...contentFrameClass,
        'content-frame': true,
        'boards-to-reports': isBoardsToReportsEnabled,
        'inherit-size': isBoardsToReportsEnabled,
      }}
    >
      <div
        sel='.width-frame'
        class={{
          'inherit-size': isBoardsToReportsEnabled,
        }}
        style={{
          margin: includePadding ? `0 auto` : null,
          'max-width': maxContentWidth ? `${maxContentWidth}px` : undefined,
          'min-width': minContentWidth ? `${minContentWidth}px` : undefined,
        }}
      >
        <div
          sel='.padding-frame'
          class={{
            'inherit-size': isBoardsToReportsEnabled,
          }}
          style={{
            'box-sizing': `border-box`,
            padding: includePadding
              ? `0 ${HORIZONTAL_CONTENT_PADDING_STYLE} 6vh ${HORIZONTAL_CONTENT_PADDING_STYLE}`
              : null,
          }}
          hook={{
            insert: (vnode: VNode) => {
              if (isReportScrollContainer) {
                layoutManager.setConfig({
                  reportScrollContainer: vnode.elm as HTMLElement,
                });
              }
              onPaddingFrameInsert?.(vnode);
            },
          }}
        >
          {block}
        </div>
      </div>
    </div>
  );
}
